import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const updateTrainingStatus = (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}user/action/setTraining`

  try {
    const response = fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    return response
  } catch (error) {
    console.log(error)
  }
}

export const updateHutritNextStatus = (data) => {
  const rawBody = JSON.stringify(data)

  const URL = `${BASE_URL}user/action/setHutrittNext`

  try {
    const response = fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })

    return response
  } catch (error) {
    console.log(error)
  }
}
